/**
 * http请求的统一出口，方便统一处理，暂时透传。
 */
import axios from 'axios';
import Cookies from 'js-cookie';
import { toLocale } from '@ok/blade';

import Page from '_common/constants/PageLink';
import UTIL from '_common/utils/util';

import config from '../config';

// axios.defaults.headers.common.Authorization = localStorage.getItem('token') || '';
// axios.defaults.headers.common.devId = UTIL.getDeviceId();
axios.defaults.headers.common.timeout = config.timeout;
axios.defaults.headers.common['App-Type'] = 'web';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

// 判断相应 状态码
function statusFunc(response) {
  const { status, data } = response || {};
  const errorObj = {
    status: status || '',
    msg: toLocale('serverError'),
  };
  if (status >= 200 && status < 300) {
    const newToken = response.headers['x-ok-token'];
    if (newToken && newToken.length !== 0) {
      localStorage.setItem('token', newToken);
      // 临时兼容ont逻辑，后续会替换本模块
      Cookies.set('isLogin', 1, { expires: 7 });
    }
    if (data && data.code === 0) {
      // code 为0 的正常情况 成功
      return Promise.resolve(data);
    } else if (data && data.code === 800) {
      // alert('dataProxy+' + response.config.url);
      // 令牌失效 跳转登录
      window.location.href = `${Page.login}?logout=true&forward=${window.location.pathname}${window.location.search}${window.location.hash}`;
      return Promise.resolve(data);
    }
    // code不为0的情况 放到错误中处理
    return Promise.reject(data);
  } else if (response.status === 401 || response.status === 403) {
    // 令牌无效 跳转登录
    // alert('dataProxy+' + response.config.url);
    localStorage.removeItem('token');
    Cookies.remove('isLogin');
    window.location.href = `${Page.login}?logout=true&forward=${window.location.pathname}${window.location.search}${window.location.hash}`;
    errorObj.msg = '';
    return Promise.reject(errorObj);
  }
  return Promise.reject(errorObj);
}

axios.interceptors.request.use(
  (defaultConfig) => {
    const configObj = defaultConfig;
    configObj.headers.Authorization = localStorage.getItem('token') || '';
    configObj.headers.devId = UTIL.getDeviceId();
    return configObj;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 处理统一处理
axios.interceptors.response.use(
  (response) => {
    return statusFunc(response);
  },
  (res) => {
    return statusFunc(res.response);
  }
);

export default {
  // 表单提交封装
  postForm(url, params) {
    const formData = new FormData();
    Object.entries(params || {}).forEach((kv) => {
      formData.append(kv[0], kv[1]);
    });
    const headers = Object.assign(axios.defaults.headers.common, {
      'Content-Type': 'multipart/form-data;',
    });
    headers['Content-Type'] = 'multipart/form-data;';
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, headers)
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  download(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, params)
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  get(url, params) {
    return new Promise((resolve, reject) => {
      // 为get请求添加获取APP webview传来的token的逻辑
      const headers = {};
      if (navigator.userAgent.includes('OKApp')) {
        window.jsbridge
          .getToken()
          .then((appToken) => {
            if (appToken) {
              localStorage.setItem('token', appToken);
              headers.Authorization = appToken;
            }
            axios
              .get(url, { params, headers })
              .then((res) => {
                resolve(res);
              })
              .catch((res) => {
                reject(res);
              });
          })
          .catch(() => {});
      } else {
        axios
          .get(url, params)
          .then((res) => {
            resolve(res);
          })
          .catch((res) => {
            reject(res);
          });
      }
    });
  },
};

// export default axios;
